import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function TitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    function getTitle(pathname) {
      return pathname
        .split("/")
        .filter((p) => p !== "")
        .map((p) => {
          const newName = p.replace(/-|_/g, " ");
          return newName.charAt(0).toUpperCase() + newName.slice(1);
        })
        .join(" | ");
    }

    if (location.pathname === "/") {
      document.title = "VideoOS - Automated Video Editing and Metadata Tagging for Enterprises";
    } else {
      document.title = getTitle(location.pathname);
    }
  }, [location.pathname]);

  return null;
}

export default TitleUpdater;
